export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5321.bb5ce2a1.jpg";